import { CityState, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderQuickInfo extends Layout {
	destCityState: CityState;
	originCityState: CityState;
	panelQuickInfo: Panel;
	sourceOrderCustomerStop: DataSource;
	textboxCustomerName: Textbox;
	textboxDestPickupWindow: Textbox;
	textboxDestStoplocationName: Textbox;
	textboxOrderStatus: Textbox;
	textboxOrderscommodity: Textbox;
	textboxOriginPickupWindow: Textbox;
	textboxOriginStoplocationName: Textbox;
}
